import {
    AccessibilityNew, Biotech, Devices,
    Psychology, Security, VerifiedUser,
    Palette, PsychologyAlt,
    MobileFriendly,
    MobileOff,
    Apple, Android,
    FlutterDash, TipsAndUpdatesOutlined, Money,
    Help,
    CarRental,
    RocketLaunch,
    House,
    Explore,
    Google,
} from '@mui/icons-material';
import { GoogleAuthProvider } from 'firebase/auth';

interface _ServiceSolution {
    id: string,
    title: string | undefined,
    description: string | undefined,
    topics: Topic[] | undefined,
}

interface _Topic {
    id: string,
    name: string | undefined,
    icon: typeof AccessibilityNew | undefined,
    description: string | undefined,
    isVisible?: boolean,
}

export class Topic implements _Topic {
    constructor(
        public id: string,
        public name: string | undefined,
        public icon: typeof AccessibilityNew | undefined,
        public description: string | undefined,
        public isVisible: boolean = true,
    ) {
    }
}

export class ServiceSolution implements _ServiceSolution {
    constructor(
        public id: string,
        public title: string | undefined,
        public description: string | undefined,
        public extraDetail: string | undefined,
        public isVisible: boolean = true,
        public topics: Topic[],
    ) {
    }
}


export const serviceSolutionList: ServiceSolution[] = [
    {
        id: "z_svcsoln-mdap",
        title: "Mobile App Development",
        description: "Mobile app development is the process of creating software applications that run on mobile devices, such as smartphones and tablets." +
         "This involves designing, coding, testing, and deploying apps that provide users with a seamless and engaging experience." +
         "The goal of mobile app development is to create" +
         " applications that are user-friendly, efficient, and tailored to the specific needs of the target audience, while also considering" +
         " the factors like performance, security, and compatibility across different devices and operating systems.",
        extraDetail: "Mobile app development can be done using various programming languages and frameworks, including native " +
         "development (using Swift for iOS and Kotlin for Android), cross-platform frameworks (like React Native and Flutter), and" +
         " hybrid approaches (using web technologies like HTML, CSS, and JavaScript). ",
        isVisible: true,
        topics: [
        new Topic(
            "ic1",
            "AI Development",
            TipsAndUpdatesOutlined,
            "Integrating AI capabilities into mobile applications to enhance user experience, automate tasks, and provide intelligent features such as prompt engineering, natural language processing, image recognition, and predictive analytics.",
        ),
        new Topic(
            "ic2",
            "Native iOS (Swift/UI)",
            Apple,
            "Native iOS development using Swift and SwiftUI to create high-performance, visually appealing applications tailored for Apple devices.",
        ),
        new Topic(
            "ic3",
            "Native Android (Kotlin)",
            Android,
            "Native Android development using Kotlin and Jetpack Compose to create high-performance, visually appealing applications tailored for Android devices.",
        ),
        new Topic(
            "ic4",
            "ReactJS",
            MobileFriendly,
            "A popular JavaScript library for building user interfaces with reusable components and a virtual DOM for performance.",
        ),
        new Topic(
            "ic5",
            "Flutter Dart",
            FlutterDash,
            "Flutter is an open-source UI software development toolkit created by Google. It is used to develop cross-platform applications from a single codebase, allowing developers to create natively compiled applications for mobile, web, and desktop from a single codebase. Dart is the programming language used to build Flutter apps.",
            false,
        ),
        ]
    },
    {
        id: "c_svcsoln-gen-ai",
        title: "Generative AI",
        description: "Generative AI refers to a category of artificial intelligence algorithms designed to " +
            "create new content, ranging from text and images to music and code. These models learn underlying "
            + "patterns and structures from input training data and then generate similar, yet novel, outputs. ",
        extraDetail: "The purpose of generative AI is to automate creative processes, personalize user experiences, and "
            + "facilitate innovation in various fields, from art and entertainment to science and engineering.",
        isVisible: true,
        topics: [new Topic(
            "ic6",
            "Gemini & Vertex",
            CarRental,
            "Gemini, hosted on Vertex AI, provides powerful foundation models for building intelligent and generative "
            + "features into mobile applications.",
        )]
    },
    {
        id: "b_svcsoln-assistive-ai",
        title: "AI Assistive Apps",
        description: "mobidawg can create AI-assistive applications that augment human capabilities, automate repetitive tasks, and provide data-driven insights to boost productivity and improve decision-making.",
        extraDetail: "",
        isVisible: true,
        topics: [new Topic(
            "ic7",
            "Gemini Models",
            Google,
            "Using Gemini Models to build smart, detailed content to applications that augment the user experience.",
        )]
    },
    {
        id: "d_svcsoln-tech",
        title: "Mobile Technology",
        description: "mobidawg stays at the forefront of mobile technology, specializing in AI Integration and secure, high-performance architectures to deliver future-proof solutions.",
        extraDetail: "",
        isVisible: true,
        topics: [new Topic(
            "ic8",
            "Firebase & Google Cloud",
            RocketLaunch,
            "Firebase and Google Cloud provide a comprehensive suite of tools and services for building, deploying, and scaling mobile applications with robust backend infrastructure, real-time databases, authentication, and cloud functions.",
        )]
    },
    {
        id: "bb_svcsoln-architecture",
        title: "Mobile Architecture",
        description: "mobidawg brings robust designs and scalable mobile architectures that ensure high performance, security, and a seamless user experience, tailored to meet your business and user demands.",
        extraDetail: "",
        isVisible: true,
        topics: [new Topic(
            "ic9",
            "Clean Architecture",
            House,
            "Clean Architecture is a software design philosophy that emphasizes separation of concerns, modularity, and maintainability by organizing code into layers with clear dependencies, allowing for easier testing, scalability, and adaptability to changing requirements.",
        )]
    },
    {
        id: "e_svcsoln-ux-design",
        title: "User Experience Design ****",
        description: "mobidawg focuses on enhancing user satisfaction by improving the usability, accessibility, and overall pleasure of the user's interaction with your product, grounded in research and testing.",
        extraDetail: "",
        isVisible: false,
        topics: [new Topic(
            "ic10",
            "name",
            Explore,
            "",
        )],
    },

];
